var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKomeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.696 16.688V13.608L8.008 15.148L7 13.384L9.66 11.844L7 10.304L8.008 8.54L10.696 10.08V7H12.74V10.08L15.4 8.54L16.408 10.304L13.748 11.844L16.408 13.384L15.4 15.148L12.74 13.608V16.688H10.696Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKomeMark);
export default __webpack_public_path__ + "static/media/kome_mark.999e786ee18392fc0c8a25a7ceb68219.svg";
export { ForwardRef as ReactComponent };